<template>
  <div ref="chart" style="width:100%; height:100%;"></div>
</template>

<script>
import echarts from 'echarts';
export default {
  props:{
    options:{
      type:Object,
      default:()=>{}
    },
    config:{
      type:Object,
      default:()=>{}
    }
  },
  data(){
    return {
      chartLine:null
    }
  },
  watch:{
    options:{
      deep:true,
      handler(val){
        this.initChart();
      }
    }
  },
  mounted(){
    this.initChart();
    window.addEventListener('resize',()=>{
      if(this.chartLine){
        this.chartLine.resize()
      }
    }) ;
  },
  methods: {
    async initChart() {
      this.chartLine = echarts.init(this.$refs.chart,'mytheme');
      let option = {
        tooltip: {
          trigger: "axis",
        },
        grid:{
          containLabel:true,
          left:'3%',
          top:'18%',
          right:'3%',
          bottom:'10%'
        },
        legend: {
          /* textStyle:{
            color:' #4e9dfd'
          }, */
          itemHeight:8,
        },
        xAxis: [
          {
            type: "category",
            /* axisLine:{
              lineStyle:{
                color:'#0f2652'
              }
            }, */
            axisLabel:{
              // color:'#0f9cf0',
              rotate:45,
              showMaxLabel:true,
              
            },
            splitLine:{
              show:false,
              /* lineStyle:{
                color:'#40559f'
              } */
            },
            axisTick:{
              show:true
            },
            data: this.options.x,
          },
        ],
        yAxis: [
          {
            type: "value",
            name:this.config.unit,
            scale:true,
           /*  nameTextStyle:{
              color:'#00a0ec'
            }, */
            splitLine:{
              show:true,
              /* lineStyle:{
                color:'#40559f'
              } */
            },
            axisLabel:{
              // color:'#0f9cf0',
            },
            axisTick:{
              show:false
            },
            axisLine:{
              /* lineStyle:{
                color:'#0f2652'
              } */
            },
          },
        ],
        series: this.options.series,
      };

      this.chartLine.setOption(option)
    },
  },
  beforeDestroy() {
    if (!this.chartLine) {
      return;
    }
    this.chartLine.dispose();
    this.chartLine = null;
  },
};
</script>
